import { createContext } from 'react';
import store, { StateInterface } from 'store';
import { Store } from 'effector';

export default createContext<Store<StateInterface>>(store);
